import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayModes } from '../../../models/enums';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { CallRateCalculationsService } from '../call-rate-calculations.service';
import { BusinessUnitService } from '../../business-unit/business-unit.service';
import { HelperMethodsService } from '../../../services/helper-methods.service';

@Component({
  selector: 'crm-add-call-rate-calculations',
  templateUrl: './add-call-rate-calculations.component.html',
  styleUrls: ['./add-call-rate-calculations.component.css']
})
export class AddCallRateCalculationsComponent implements OnInit {
  businessUnits: any[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  callRateCalculation = {} as any;
  startDate: any;
  endDate: any;
  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() callRateCalculationId: number;
  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 10,
    allowSearchFilter: true
  };

  numeratorTypes = [{ id: 0, name: 'Total Visits' }, { id: 1, name: 'Hcp Visits Only' }]

  denominatorTypes = [{ id: 2, name: 'Field Days' }, { id: 3, name: 'Field Shifts' }
    , { id: 4, name: 'Fields Days Am' }, { id: 5, name: 'Fields Days Pm' }]


  constructor(private readonly callRateCalculationsService: CallRateCalculationsService,
    private readonly route: ActivatedRoute, private readonly helperMethods: HelperMethodsService,
    private readonly router: Router, private businessUnitService: BusinessUnitService,
    private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService) { }

  ngOnInit() {
    this.startDate = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() + 1
    };
    // this.endDate = {
    //   year: new Date().getFullYear() + 1,
    //   month: new Date().getMonth() + 1,
    //   day: new Date().getDate() + 10
    // };

    if (this.callRateCalculationId != undefined)
      this.getCallRateCalculation(this.callRateCalculationId);

    this.getBusinessUnitsRootLevel();
  }

  getCallRateCalculation(callRateCalculationId) {
    this.displayMode = DisplayModes.Loading;
    this.callRateCalculationsService.getById(callRateCalculationId).subscribe(responce => {
      this.displayMode = DisplayModes.Success;
      this.callRateCalculation = responce as any;

      if (this.businessUnits && this.callRateCalculation.businessUnits) {
        this.callRateCalculation.businessUnitIds = [];
        this.callRateCalculation.businessUnits.forEach((m) => {
          let c: any = {} as any;
          c.id = m.businessUnitId;
          if (this.businessUnits.find(x => x.id == m.businessUnitId))
            c.name = this.businessUnits.find(x => x.id == m.businessUnitId).name;
          this.callRateCalculation.businessUnitIds.push(c);
        });
      }


      if (this.callRateCalculation.denominator)
        this.callRateCalculation.denominatorType = this.denominatorTypes.find(x => { return x.id === this.callRateCalculation.denominator; });

      if (this.callRateCalculation.numerator)
        this.callRateCalculation.numeratorType = this.numeratorTypes.find(x => { return x.id === this.callRateCalculation.numerator; });


      let sDate = new Date(this.callRateCalculation.startDate);
      this.startDate = {
        year: sDate.getFullYear(),
        month: sDate.getMonth() + 1,
        day: sDate.getDate()
      };

      if (this.callRateCalculation.endDate !== null) {
        this.endDate = {
          year: new Date(this.callRateCalculation.endDate).getFullYear(),
          month: new Date(this.callRateCalculation.endDate).getMonth() + 1,
          day: new Date(this.callRateCalculation.endDate).getDate()
        }
      }

    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get call Rate Calculation');
        console.log(err);
      });
  }

  save(form) {
    if (!form.invalid) {

      this.displayMode = DisplayModes.Loading;

      this.callRateCalculation.businessUnits = [];
      if (this.callRateCalculation.businessUnitIds) {
        this.callRateCalculation.businessUnitIds.forEach((bu) => {
          let x: any = { businessUnitId: bu.id };

          this.callRateCalculation.businessUnits.push(x);
        });
      }

      this.callRateCalculation.startDate = this.helperMethods.convertDateToUTC(new Date(this.startDate.year, this.startDate.month - 1, this.startDate.day + 1));

      if (this.endDate !== undefined)
        this.callRateCalculation.endDate = this.helperMethods.convertDateToUTC(new Date(this.endDate.year, this.endDate.month - 1, this.endDate.day + 1));


      if (this.callRateCalculation.denominatorType)
        this.callRateCalculation.denominator = this.callRateCalculation.denominatorType.id;

      if (this.callRateCalculation.numeratorType)
        this.callRateCalculation.numerator = this.callRateCalculation.numeratorType.id;

      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.callRateCalculationsService.save(this.callRateCalculation).subscribe(() => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.back();
        this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
    }
  }

  getBusinessUnitsRootLevel() {
    this.businessUnitService.getAllBusinessUnits().subscribe(response => {
      this.businessUnits = response as any[];

      if (this.callRateCalculation && this.callRateCalculation.businessUnits) {
        this.callRateCalculation.businessUnitIds = [];
        this.callRateCalculation.businessUnits.forEach((m) => {
          let c: any = {} as any;
          c.id = m.businessUnitId;
          if (this.businessUnits.find(x => x.id == m.businessUnitId))
            c.name = this.businessUnits.find(x => x.id == m.businessUnitId).name;
          this.callRateCalculation.businessUnitIds.push(c);
        });
      }
      // if (this.callRateCalculation)
      //   this.callRateCalculation.businessUnit = this.businessUnits.find(x => { return x.id === this.callRateCalculation.businessUnitId; });
    }, error => { });
  }


  back() {
    this.closeEvent.emit(true);
  }

  onSelectAllBussinessUnits(bu) {
    this.callRateCalculation.businessUnits = bu;
  }

  onChangeBu() {

  }
}
